import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material';

import { REJECTION_REASONS } from '@constants';
import { optionRowSx } from './optionRowSx';
import { CandidateFeedbackFormik } from '@types';

export const CandidateRejectionReasons: React.FC<{
  formik: CandidateFeedbackFormik;
}> = ({ formik }) => {
  const rejectionReasonError =
    ((formik.submitCount || formik.touched.rejectionReasons) &&
      formik.errors.rejectionReasons) ||
    '';

  return (
    <Stack
      px={3}
      pt={2.5}
      pb={1}
      borderRadius={1}
      bgcolor="background.backgroundPrimary"
    >
      <FormControl>
        <FormLabel sx={{ fontSize: '0.75rem' }} error={!!rejectionReasonError}>
          Please select the reason
        </FormLabel>
        <RadioGroup
          sx={{ ...optionRowSx, mt: 1, mx: -0.5 }}
          id="rejectionReasons"
          name="rejectionReasons"
          value={formik.values.rejectionReasons?.[0] || ''}
          onChange={(e) => {
            formik.setFieldValue('rejectionReasons', [e.target.value]);
          }}
        >
          {REJECTION_REASONS.map((reason) => (
            <FormControlLabel
              key={reason}
              value={reason}
              control={<Radio />}
              label={reason}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};
